<div class="p-d-flex p-flex-column" style="height: 100%">
  <kodit-field fieldLabel="Broj, originalni broj računa ili naziv dobavljača" class="p-fluid">
    <p-autoComplete
      [suggestions]="ufSuggestions"
      (completeMethod)="handleSearch($event)"
      (onSelect)="selectionChanged($event)"
      appendTo="body"
      field="originalniBroj"
    >
      <ng-template let-item pTemplate="item">
        <div class="p-d-flex p-ai-center">
          {{ item.broj }} - {{ item.originalniBroj }} - {{ item.dobavljac }}
        </div>
      </ng-template>
    </p-autoComplete>
  </kodit-field>
  <kodit-divider class="p-mt-1"></kodit-divider>
  <div *ngIf="stavke.length === 0" class="p-d-flex p-jc-center p-ai-center" style="height: 100%">
    Odaberite ulaznu fakturu kako biste dodali zavisne troškove
  </div>
  <div *ngIf="stavke.length > 0" class="p-d-flex p-flex-column p-jc-between" style="height: 100%">
    <div class="p-d-flex p-flex-column">
      <h4>Stavke</h4>
      <!-- Table -->
      <div class="stavke">
        <!-- Header -->
        <div class="row header p-d-flex p-ai-center">
          <div class="cell naziv">Naziv</div>
          <div class="cell cena right">Cena bez PDV-a</div>
          <div class="cell cena right">Cena sa PDV-om</div>
        </div>

        <!-- Rows -->
        <div
          class="row p-d-flex p-ai-center"
          *ngFor="let s of stavke"
        >
          <div class="cell checkbox">
            <p-checkbox
              [(ngModel)]="selectedStavke"
              name="selectedStavke"
              [value]="s"></p-checkbox>
          </div>
          <div class="cell naziv">{{ s.naziv }}</div>
          <div class="cell cena right muted p-jc-end">
            {{ s.iznosBezPdv | currencyNumber: 'RSD' }}
          </div>
          <div class="cell cena right">
            {{ s.iznosSaPdv | currencyNumber: 'RSD' }}
          </div>
        </div>

      </div>
    </div>
    <div class="p-d-flex p-jc-end p-ai-center">
      <kodit-button
        btnClass="p-button-outlined"
        btnLabel="Otkaži"
        (btnClicked)="onClose()"
      >
      </kodit-button>
      <kodit-button
        class="p-ml-1"
        btnLabel="Dodaj"
        [isBtnDisabled]="selectedStavke.length === 0"
        (btnClicked)="onSubmit()"
      >
      </kodit-button>
    </div>
  </div>
</div>
